import { render } from "./Invite.vue?vue&type=template&id=10b11f44&ts=true"
import script from "./Invite.vue?vue&type=script&lang=ts"
export * from "./Invite.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/on-the-edge-admin/on-the-edge-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__